import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomerSiteDto } from '@app/generated/model';

export const buildCustomerSiteForm = (
  formBuilder: UntypedFormBuilder,
  customerSite: CustomerSiteDto,
): UntypedFormGroup => {
  const form = formBuilder.group({
    siteCode: ['', Validators.required],
    siteName: ['', Validators.required],
  });

  form.patchValue(customerSite);

  return form;
};
